import {
  React,
  PingHistoryLogs,
  useGetpinglogMutation,
  useEffect,
  useLocation,
  toast,
  useState,
  Box,
  TabView,
  TabPanel,
  GetCookie,
} from "../../../Libraries/Screens/index";

const PingHistory = () => {

  const [Pinglog] = useGetpinglogMutation();
  const location = useLocation();

  const [logsdata, setlogsdata] = useState({
    pinglogsdata: null,
    bandwidthlogsdata: null,
  });

  useEffect(() => {
    const Pinglogs = async () => {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_screen_id", location.state);

      try {
        const response = await Pinglog(payload).unwrap();
        if (
          response.status === "true" &&
          response.connection === "true" &&
          response.message === "Ping logs available"
        ) {
          setlogsdata({
            pinglogsdata: response.data,
          });
        } else {
          toast.info(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (location.state !== null) {
      Pinglogs();
    }
  }, [Pinglog, location]);

  return (
    <>
      <Box sx={{ flexGrow: 1, mr: 3, mt: 3 }}>
        <TabView
          style={{ borderTopRightRadius: "8px", borderTopLeftRadius: "8px" }}
        >
          <TabPanel header="PING LOGS">
            <PingHistoryLogs
              logs={
                logsdata.pinglogsdata !== null ? logsdata.pinglogsdata : null
              }
            />
          </TabPanel>
        </TabView>
      </Box>
    </>
  );
};

export default PingHistory;
